import { render, staticRenderFns } from "./IdentificacaoSolicitacao.vue?vue&type=template&id=7c0afeb0&"
import script from "./IdentificacaoSolicitacao.vue?vue&type=script&lang=js&"
export * from "./IdentificacaoSolicitacao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports